// Calculadora pública de Carta Natal (gratis, sin quiz de personalidad).
// Reutiliza datos de rf-preguntas.js (signos, países) y el mismo motor de
// signo solar que el teaser del quiz. Resultado instantáneo, sin muro de email.
// Config: window.RF_CFG { stripeUrl, precioTexto, locale } (sections/rf-calculadora.liquid).
// i18n: textos por idioma en I18N (es = base; en/fr/de). Los nombres de signo y de país
// se traducen por posición/código sobre RF_QUIZ, sin modificar rf-preguntas.js (lo comparte el quiz).
(function () {
  var cont = document.getElementById("rf-calc-app");
  if (!cont) return;
  var QUIZ = window.RF_QUIZ;
  var CFG = window.RF_CFG || {};
  var nac = null;
  var codigo = { enfoque: "p", momento: "4", nivel: "a" };

  var I18N = {
    es: {
      fecha: "Fecha de nacimiento",
      hora: "Hora de nacimiento",
      sinHora: "No sé mi hora exacta (se calcula igual)",
      pais: "País donde naciste",
      ciudad: "Ciudad donde naciste",
      ciudadPh: "Ej. Guadalajara",
      calcular: "Calcular mi carta gratis",
      errFecha: "Completa tu fecha de nacimiento.",
      notaHora: "Sin hora exacta tu carta se calcula en modo solar (sin Ascendente ni casas) — igual de válida para todo lo demás.",
      tuSol: "Tu Sol está en",
      energia: function (n, d) { return "Energía " + n + ": " + d + "."; },
      esteSigno: 'Este es tu signo solar — <strong>1 de los 12 puntos</strong> de tu carta real. Con tu fecha, hora y lugar exactos calculamos los otros 11:',
      luna: "🔒 Tu <strong>Luna</strong> (tu mundo emocional real)<br>",
      asc: "🔒 Tu <strong>Ascendente</strong> (cómo te ve el mundo)<br>",
      venusMarte: "🔒 <strong>Venus y Marte</strong> (cómo amas y deseas)<br>",
      medioCielo: "🔒 Tu <strong>Medio Cielo</strong> (vocación y dinero)<br>",
      aspectos: "🔒 Los <strong>aspectos</strong> entre tus planetas (tus patrones)",
      cartaCompleta: "Tu Carta Natal completa",
      li1: "<strong>Rueda natal calculada</strong> con efemérides suizas — precisión de software profesional",
      li2: "Posiciones exactas de tus 10 planetas, en signos y casas",
      li3: "Tus tres grandes integrados: Sol, Luna y Ascendente",
      li4: "Informe de 15+ páginas en PDF, a tu correo en menos de 1 hora",
      precioNota: "Pago único. Sin suscripción, sin cargos recurrentes.",
      comprar: "Quiero mi carta completa",
      errPago: "No pudimos iniciar el pago. Intenta de nuevo.",
      garantia: "🛡️ Garantía de 7 días: si no te aporta, te devolvemos el 100%.",
      otra: "Calcular otra fecha",
      preparando: "Preparando tu pago…",
      signos: null, // null = usa los de rf-preguntas.js (es)
      paises: null
    },
    en: {
      fecha: "Date of birth",
      hora: "Time of birth",
      sinHora: "I don't know my exact time (it's calculated anyway)",
      pais: "Country where you were born",
      ciudad: "City where you were born",
      ciudadPh: "e.g. Guadalajara",
      calcular: "Calculate my chart free",
      errFecha: "Enter your date of birth.",
      notaHora: "Without an exact time your chart is calculated in solar mode (no Ascendant or houses) — just as valid for everything else.",
      tuSol: "Your Sun is in",
      energia: function (n, d) { return n + " energy: " + d + "."; },
      esteSigno: 'This is your sun sign — <strong>1 of the 12 points</strong> of your real chart. With your exact date, time and place we calculate the other 11:',
      luna: "🔒 Your <strong>Moon</strong> (your real emotional world)<br>",
      asc: "🔒 Your <strong>Ascendant</strong> (how the world sees you)<br>",
      venusMarte: "🔒 <strong>Venus and Mars</strong> (how you love and desire)<br>",
      medioCielo: "🔒 Your <strong>Midheaven</strong> (vocation and money)<br>",
      aspectos: "🔒 The <strong>aspects</strong> between your planets (your patterns)",
      cartaCompleta: "Your complete Natal Chart",
      li1: "<strong>Calculated natal wheel</strong> with Swiss ephemeris — professional software precision",
      li2: "Exact positions of your 10 planets, in signs and houses",
      li3: "Your integrated big three: Sun, Moon and Ascendant",
      li4: "15+ page PDF report, delivered to your inbox in under 1 hour",
      precioNota: "One-time payment. No subscription, no recurring charges.",
      comprar: "I want my complete chart",
      errPago: "We couldn't start the payment. Please try again.",
      garantia: "🛡️ 7-day guarantee: if it doesn't add anything for you, we refund 100%.",
      otra: "Calculate another date",
      preparando: "Preparing your payment…",
      signos: [
        ["Capricorn", "a patient builder, more sensitive than you show"],
        ["Aquarius", "a free mind: you see what others don't see yet"],
        ["Pisces", "deep intuition — you feel the tide before anyone else"],
        ["Aries", "fire that starts things: where others hesitate, you've already begun"],
        ["Taurus", "presence and constancy: you build things that last"],
        ["Gemini", "infinite curiosity — your mind never gets bored"],
        ["Cancer", "deep emotional memory: you care like no one else"],
        ["Leo", "a heart that radiates: you were born to be seen"],
        ["Virgo", "a precise eye: you improve everything you touch"],
        ["Libra", "you seek harmony and the right balance in things"],
        ["Scorpio", "transformative intensity: nothing halfway"],
        ["Sagittarius", "an arrow to the horizon: you need meaning, not routine"]
      ],
      paises: { MX: "Mexico", US: "United States", CO: "Colombia", GT: "Guatemala", AR: "Argentina", ES: "Spain", PE: "Peru", CL: "Chile", EC: "Ecuador", VE: "Venezuela", BO: "Bolivia", HN: "Honduras", SV: "El Salvador", NI: "Nicaragua", CR: "Costa Rica", PA: "Panama", DO: "Dominican Republic", PY: "Paraguay", UY: "Uruguay", PR: "Puerto Rico", OTRO: "Other country" }
    },
    fr: {
      fecha: "Date de naissance",
      hora: "Heure de naissance",
      sinHora: "Je ne connais pas mon heure exacte (le calcul se fait quand même)",
      pais: "Pays de naissance",
      ciudad: "Ville de naissance",
      ciudadPh: "Ex. Guadalajara",
      calcular: "Calculer ma carte gratuitement",
      errFecha: "Indique ta date de naissance.",
      notaHora: "Sans l'heure exacte, ta carte est calculée en mode solaire (sans Ascendant ni maisons) — tout aussi valable pour le reste.",
      tuSol: "Ton Soleil est en",
      energia: function (n, d) { return "Énergie " + n + " : " + d + "."; },
      esteSigno: "Voici ton signe solaire — <strong>1 des 12 points</strong> de ta vraie carte. Avec ta date, ton heure et ton lieu exacts, nous calculons les 11 autres :",
      luna: "🔒 Ta <strong>Lune</strong> (ton vrai monde émotionnel)<br>",
      asc: "🔒 Ton <strong>Ascendant</strong> (comment le monde te voit)<br>",
      venusMarte: "🔒 <strong>Vénus et Mars</strong> (comment tu aimes et désires)<br>",
      medioCielo: "🔒 Ton <strong>Milieu du Ciel</strong> (vocation et argent)<br>",
      aspectos: "🔒 Les <strong>aspects</strong> entre tes planètes (tes schémas)",
      cartaCompleta: "Ta carte du ciel complète",
      li1: "<strong>Roue natale calculée</strong> avec les éphémérides suisses — précision d'un logiciel professionnel",
      li2: "Positions exactes de tes 10 planètes, en signes et maisons",
      li3: "Ton big three intégré : Soleil, Lune et Ascendant",
      li4: "Rapport PDF de 15+ pages, dans ta boîte mail en moins d'une heure",
      precioNota: "Paiement unique. Sans abonnement, sans frais récurrents.",
      comprar: "Je veux ma carte du ciel complète",
      errPago: "Nous n'avons pas pu lancer le paiement. Réessaie.",
      garantia: "🛡️ Garantie de 7 jours : si ça ne t'apporte rien, on te rembourse 100 %.",
      otra: "Calculer une autre date",
      preparando: "Préparation de ton paiement…",
      signos: [
        ["Capricorne", "tu construis avec patience et tu es plus sensible que tu ne le montres"],
        ["Verseau", "esprit libre : tu vois ce que les autres ne voient pas encore"],
        ["Poissons", "intuition profonde — tu sens la marée avant tout le monde"],
        ["Bélier", "feu qui commence : là où les autres hésitent, tu as déjà commencé"],
        ["Taureau", "présence et constance : tu construis des choses qui durent"],
        ["Gémeaux", "curiosité infinie — ton esprit ne s'ennuie jamais"],
        ["Cancer", "mémoire émotionnelle profonde : tu prends soin comme personne"],
        ["Lion", "un cœur qui rayonne : tu es né(e) pour être vu(e)"],
        ["Vierge", "œil précis : tu améliores tout ce que tu touches"],
        ["Balance", "tu cherches l'harmonie et le juste équilibre des choses"],
        ["Scorpion", "intensité transformatrice : rien à moitié"],
        ["Sagittaire", "une flèche vers l'horizon : tu as besoin de sens, pas de routine"]
      ],
      paises: { MX: "Mexique", US: "États-Unis", CO: "Colombie", GT: "Guatemala", AR: "Argentine", ES: "Espagne", PE: "Pérou", CL: "Chili", EC: "Équateur", VE: "Venezuela", BO: "Bolivie", HN: "Honduras", SV: "Salvador", NI: "Nicaragua", CR: "Costa Rica", PA: "Panama", DO: "République dominicaine", PY: "Paraguay", UY: "Uruguay", PR: "Porto Rico", OTRO: "Autre pays" }
    },
    de: {
      fecha: "Geburtsdatum",
      hora: "Geburtszeit",
      sinHora: "Ich kenne meine genaue Zeit nicht (es wird trotzdem berechnet)",
      pais: "Land, in dem du geboren wurdest",
      ciudad: "Stadt, in der du geboren wurdest",
      ciudadPh: "z. B. Guadalajara",
      calcular: "Mein Horoskop kostenlos berechnen",
      errFecha: "Gib dein Geburtsdatum ein.",
      notaHora: "Ohne genaue Uhrzeit wird dein Horoskop im Sonnenmodus berechnet (ohne Aszendent und Häuser) — für alles andere genauso gültig.",
      tuSol: "Deine Sonne steht in",
      energia: function (n, d) { return n + "-Energie: " + d + "."; },
      esteSigno: "Das ist dein Sonnenzeichen — <strong>1 der 12 Punkte</strong> deines echten Horoskops. Mit deinem genauen Datum, deiner genauen Zeit und deinem genauen Ort berechnen wir die anderen 11:",
      luna: "🔒 Dein <strong>Mond</strong> (deine echte Gefühlswelt)<br>",
      asc: "🔒 Dein <strong>Aszendent</strong> (wie die Welt dich sieht)<br>",
      venusMarte: "🔒 <strong>Venus und Mars</strong> (wie du liebst und begehrst)<br>",
      medioCielo: "🔒 Dein <strong>Medium Coeli</strong> (Berufung und Geld)<br>",
      aspectos: "🔒 Die <strong>Aspekte</strong> zwischen deinen Planeten (deine Muster)",
      cartaCompleta: "Dein vollständiges Geburtshoroskop",
      li1: "<strong>Berechnetes Geburtshoroskop</strong> mit Schweizer Ephemeriden — Präzision professioneller Software",
      li2: "Exakte Positionen deiner 10 Planeten, in Zeichen und Häusern",
      li3: "Deine integrierte große Drei: Sonne, Mond und Aszendent",
      li4: "PDF-Bericht mit 15+ Seiten, in unter 1 Stunde in deinem Postfach",
      precioNota: "Einmalzahlung. Kein Abo, keine wiederkehrenden Kosten.",
      comprar: "Ich möchte mein vollständiges Geburtshoroskop",
      errPago: "Wir konnten die Zahlung nicht starten. Bitte versuche es erneut.",
      garantia: "🛡️ 7-Tage-Garantie: Wenn es dir nichts bringt, erstatten wir dir 100 % zurück.",
      otra: "Anderes Datum berechnen",
      preparando: "Deine Zahlung wird vorbereitet…",
      signos: [
        ["Steinbock", "du baust geduldig auf und bist sensibler, als du zeigst"],
        ["Wassermann", "freier Geist: du siehst, was andere noch nicht sehen"],
        ["Fische", "tiefe Intuition — du spürst die Flut, bevor irgendjemand sonst sie spürt"],
        ["Widder", "Feuer, das anfängt: Wo andere zögern, hast du schon begonnen"],
        ["Stier", "Präsenz und Beständigkeit: du baust Dinge, die bleiben"],
        ["Zwillinge", "unendliche Neugier — dein Geist langweilt sich nie"],
        ["Krebs", "tiefes emotionales Gedächtnis: du sorgst dich wie niemand sonst"],
        ["Löwe", "ein Herz, das strahlt: du bist dazu geboren, gesehen zu werden"],
        ["Jungfrau", "präziser Blick: du verbesserst alles, was du anfasst"],
        ["Waage", "du suchst Harmonie und das rechte Maß der Dinge"],
        ["Skorpion", "verwandelnde Intensität: nichts halbherzig"],
        ["Schütze", "ein Pfeil zum Horizont: du brauchst Sinn, keine Routine"]
      ],
      paises: { MX: "Mexiko", US: "USA", CO: "Kolumbien", GT: "Guatemala", AR: "Argentinien", ES: "Spanien", PE: "Peru", CL: "Chile", EC: "Ecuador", VE: "Venezuela", BO: "Bolivien", HN: "Honduras", SV: "El Salvador", NI: "Nicaragua", CR: "Costa Rica", PA: "Panama", DO: "Dominikanische Republik", PY: "Paraguay", UY: "Uruguay", PR: "Puerto Rico", OTRO: "Anderes Land" }
    }
  };
  var LANG = String(CFG.locale || document.documentElement.lang || "es").slice(0, 2).toLowerCase();
  var T = I18N[LANG] || I18N.es;

  function nombreSigno(s) {
    var i = QUIZ.signos.indexOf(s);
    return T.signos && i > -1 ? T.signos[i][0] : s.n;
  }
  function descSigno(s) {
    var i = QUIZ.signos.indexOf(s);
    return T.signos && i > -1 ? T.signos[i][1] : s.d;
  }
  function nombrePais(p) {
    return T.paises && T.paises[p.cc] ? T.paises[p.cc] : p.n;
  }

  function track(nombre, params, metaEvent) {
    try {
      if (window.gtag) gtag("event", nombre, params || {});
      if (window.fbq) {
        if (metaEvent) fbq("track", metaEvent, params || {});
        else fbq("trackCustom", nombre, params || {});
      }
    } catch (e) {}
  }

  track("calc_view", {});
  pintarFormulario();

  function pintarFormulario() {
    var opcionesPais = QUIZ.paises.map(function (p) {
      return '<option value="' + p.cc + '">' + nombrePais(p) + "</option>";
    }).join("");
    cont.innerHTML =
      '<div class="panel" style="text-align:left">' +
      '<label style="font-size:13px;font-weight:600">' + T.fecha + '</label>' +
      '<input type="date" id="rfc-fecha" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 14px;background:var(--crema)">' +
      '<label style="font-size:13px;font-weight:600">' + T.hora + '</label>' +
      '<input type="time" id="rfc-hora" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 6px;background:var(--crema)">' +
      '<label style="font-size:13px;display:block;margin-bottom:14px"><input type="checkbox" id="rfc-sinhora"> ' + T.sinHora + '</label>' +
      '<label style="font-size:13px;font-weight:600">' + T.pais + '</label>' +
      '<select id="rfc-pais" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 14px;background:var(--crema)">' + opcionesPais + "</select>" +
      '<label style="font-size:13px;font-weight:600">' + T.ciudad + '</label>' +
      '<input type="text" id="rfc-ciudad" placeholder="' + T.ciudadPh + '" style="width:100%;padding:13px;font-size:16px;font-family:inherit;border:1.5px solid var(--linea);border-radius:12px;margin:6px 0 16px;background:var(--crema)">' +
      '<button class="btn btn-block" id="rfc-calc">' + T.calcular + '</button>' +
      '<div class="error-msg" id="rfc-errn">' + T.errFecha + '</div>' +
      "</div>";

    document.getElementById("rfc-sinhora").onchange = function () {
      document.getElementById("rfc-hora").disabled = this.checked;
    };
    document.getElementById("rfc-calc").onclick = function () {
      var fecha = document.getElementById("rfc-fecha").value;
      var sinHora = document.getElementById("rfc-sinhora").checked;
      var hora = sinHora ? null : document.getElementById("rfc-hora").value;
      var ciudad = document.getElementById("rfc-ciudad").value.trim();
      var cc = document.getElementById("rfc-pais").value;
      if (!fecha) {
        document.getElementById("rfc-errn").style.display = "block";
        return;
      }
      nac = { fecha: fecha, hora: hora, ciudad: ciudad || "", cc: cc };
      track("calc_submit", {});
      resultado();
    };
  }

  function signoSolar(fecha) {
    var m = parseInt(fecha.slice(5, 7), 10), d = parseInt(fecha.slice(8, 10), 10);
    for (var i = 0; i < QUIZ.signos.length; i++) {
      var s = QUIZ.signos[i];
      if (m < s.hasta[0] || (m === s.hasta[0] && d <= s.hasta[1])) return s;
    }
    return QUIZ.signos[0];
  }

  function slug(txt) {
    return txt.toLowerCase()
      .normalize("NFD").replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40);
  }

  function resultado() {
    track("calc_result", {});
    var s = signoSolar(nac.fecha);
    var precio = CFG.precioTexto || "$9.99 USD";
    var notaHora = nac.hora ? "" :
      '<p style="font-size:12.5px;color:var(--tinta-suave)">' + T.notaHora + '</p>';

    cont.innerHTML =
      '<div class="panel">' +
      '<p style="font-size:13px;letter-spacing:.08em;text-transform:uppercase;font-weight:600;color:var(--terracota-oscuro);margin-bottom:4px">' + T.tuSol + '</p>' +
      '<div class="arquetipo-chip">' + s.g + " " + nombreSigno(s) + "</div>" +
      "<p>" + T.energia(nombreSigno(s), descSigno(s)) + "</p>" +
      '<p style="font-size:14px">' + T.esteSigno + '</p>' +
      '<div style="text-align:left;background:var(--crema);border:1px solid var(--linea);border-radius:12px;padding:14px 18px;margin:12px 0;font-size:14.5px">' +
      T.luna +
      (nac.hora ? T.asc : "") +
      T.venusMarte +
      T.medioCielo +
      T.aspectos + "</div>" +
      "<hr style='border:none;border-top:1px solid var(--linea);margin:20px 0'>" +
      "<h2>" + T.cartaCompleta + "</h2>" +
      '<ul class="lista-plan">' +
      "<li>" + T.li1 + "</li>" +
      "<li>" + T.li2 + "</li>" +
      "<li>" + T.li3 + "</li>" +
      "<li>" + T.li4 + "</li></ul>" +
      '<div class="precio">' + precio + "</div>" +
      '<div class="precio-nota">' + T.precioNota + '</div>' +
      '<button class="btn btn-block" id="rfc-comprar">' + T.comprar + '</button>' +
      '<div class="error-msg" id="rfc-err2">' + T.errPago + '</div>' +
      notaHora +
      '<p class="garantia">' + T.garantia + '</p>' +
      '<p style="text-align:center;margin-top:18px"><button class="btn btn-ghost" id="rfc-otra" style="font-size:13px;padding:8px 16px">' + T.otra + '</button></p>' +
      "</div>";

    document.getElementById("rfc-comprar").onclick = comprar;
    document.getElementById("rfc-otra").onclick = pintarFormulario;
  }

  function comprar() {
    var btn = document.getElementById("rfc-comprar");
    btn.disabled = true;
    btn.textContent = T.preparando;
    track("begin_checkout", {}, "InitiateCheckout");

    if (!CFG.stripeUrl) {
      btn.disabled = false;
      btn.textContent = T.comprar;
      document.getElementById("rfc-err2").style.display = "block";
      return;
    }
    var partes = ["V2",
      codigo.enfoque + codigo.momento + codigo.nivel,
      nac.fecha.replace(/-/g, ""),
      nac.hora ? nac.hora.replace(":", "") : "9999",
      slug(nac.ciudad) || "sin-ciudad",
      nac.cc
    ];
    var ref = partes.join("_").slice(0, 190);
    var sep = CFG.stripeUrl.indexOf("?") === -1 ? "?" : "&";
    window.location.href = CFG.stripeUrl + sep + "client_reference_id=" + encodeURIComponent(ref);
  }
})();
